/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './procedure-medicine.reducer';

export const ProcedureMedicineDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const procedureMedicineEntity = useAppSelector(state => state.procedureMedicine.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="procedureMedicineDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.procedureMedicine.detail.title">ProcedureMedicine</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.procedureMedicine.id">Id</Translate>
            </span>
          </dt>
          <dd>{procedureMedicineEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.procedureMedicine.active">Active</Translate>
            </span>
          </dt>
          <dd>{procedureMedicineEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.procedureMedicine.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{procedureMedicineEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.procedureMedicine.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{procedureMedicineEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.procedureMedicine.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{procedureMedicineEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.procedureMedicine.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{procedureMedicineEntity.timestampentry}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.procedureMedicine.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{procedureMedicineEntity.quantity}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedureMedicine.medicine">Medicine</Translate>
          </dt>
          <dd>{procedureMedicineEntity.medicine ? procedureMedicineEntity.medicine.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedureMedicine.procedure">Procedure</Translate>
          </dt>
          <dd>{procedureMedicineEntity.procedure ? procedureMedicineEntity.procedure.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/procedure-medicine" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/procedure-medicine/${procedureMedicineEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProcedureMedicineDetail;
